import { DataAmigavel } from '@/shared/utils/datas';
import { Document, Page, Text, View, } from '@react-pdf/renderer';
import { RelatorioNucleoDto } from '@/api.types';
import { stylesDefensoresNucleo } from './styles/defensores-nucleo.style';

interface IProps {
  dados: RelatorioNucleoDto[];
}

export default function DefensorPorNucleo({ dados }: IProps) {
  const agora = new Date();
  const dataHora = `${DataAmigavel(agora)} às ${agora.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit'
  })}`;

  return (
    <Document>
      <Page size="A4" style={stylesDefensoresNucleo.page} orientation="portrait">
        <Text style={stylesDefensoresNucleo.title}>LISTA DE NÚCLEOS</Text>
        <View style={stylesDefensoresNucleo.table}>
          <View style={stylesDefensoresNucleo.tableRow}>
            <Text style={[stylesDefensoresNucleo.headerCell, { width: '30%' }]}>NÚCLEOS</Text>
            <Text style={[stylesDefensoresNucleo.headerCell, { width: '70%' }, stylesDefensoresNucleo.lastCell]}>INTEGRANTES</Text>
          </View>

          {dados.map((nucleo, index) => {
            // const lotacoes = (nucleo.lotacoes || []).sort(
            //   (a, b) => Number(b.diretor) - Number(a.diretor)
            // );
            // const membros = lotacoes.filter(a => a.defensor).map((lot, idx) => {
            //   const nome = lot.defensor?.pessoa?.nome || lot.estagio?.estagiario?.pessoa?.nome || '(indefinido)';
            //   const diretor = lot.diretor ? ' - Diretor' : '';
            //   const anotacao = lot.anotacao1 ? ` - ${lot.anotacao1}` : '';
            //   const isInativo = !lot.ativo;
            //   let style = stylesDefensoresNucleo.integrante;
            //   if (isInativo) style = stylesDefensoresNucleo.inativo;
            //   if (lot.diretor && !isInativo) style = stylesDefensoresNucleo.nomeDiretor;

            //   return (
            //     <Text key={idx} style={style}>
            //       {nome}{diretor}{anotacao}
            //     </Text>
            //   );
            // });

            return (
              <View
                style={[stylesDefensoresNucleo.tableRow, index % 2 === 0 ? stylesDefensoresNucleo.tableRowOdd : stylesDefensoresNucleo.tableRowEven]}
                key={index}
                wrap={false}
              >
                <Text style={[stylesDefensoresNucleo.tableCell, { width: '30%' }]}>
                  {nucleo.nome} ({nucleo.maximoMembros || nucleo.lotacoes?.filter(a => a.defensor)?.length} membros)
                </Text>
                {/* <View style={[stylesDefensoresNucleo.tableCell, { width: '70%' }, stylesDefensoresNucleo.lastCell]}>
                  {membros}
                </View> */}
              </View>
            );
          })}
        </View>
        <Text style={stylesDefensoresNucleo.updated}>Emitido em: {dataHora}</Text>
      </Page>
    </Document>
  );
}